<script>
import options from "./FormInputCheckbox.options"
const componentOptions = options
export default componentOptions
</script>

<template>
    <div class="be-form__input-wrapper be-form__input-checkbox">
        <div class="be-form-input-checkbox">
            <div class="be-form__input-checkbox-input-wrapper">
                <input
                    class="be-form__input-checkbox-input"
                    type="checkbox"
                    :name="inputName"
                    :value="localValue"
                    v-model="localValue"
                    @change="onChangeCallback"
                    :aria-describedby="`${inputName}__desc`"
                    :id="`${inputName}`" />
                <label :for="`${inputName}`" class="be-form__input-checkbox-label">
                    <span class="be-form__input-checkbox-label-html" v-html="label"></span>
                    {{ isRequired ? " *" : "" }}
                </label>
            </div>
        </div>

        <div aria-live="assertive">
            <p class="be-form__input-validation-error" :id="`${inputName}__desc`" role="alert" v-if="isValidationError && !disabled">
                {{ errorMessageLabel }}
            </p>
        </div>

        <p class="be-form__input-helptext" :id="`${inputName}__desc`" v-if="helpMessageLabel && !isValidationError && !disabled">
            {{ helpMessageLabel }}
        </p>
    </div>
</template>
